export default {
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
      cautions_content: '・Die Informationen, die in den Verbesserungsplan einzutragen sind, werden in {toCompanyName} angezeigt.\n・Anhänge werden in {toCompanyName} angezeigt, und nur der Dateiname wird angezeigt.',
    },
    chat: {
      card_title: 'Nachricht',
      input_area_description: 'Sie können eine Nachricht an {toCompanyName} bezüglich des Verbesserungsplans senden',
      send_confirm: {
        modal_title: 'Zu sendende Nachricht prüfen',
        confirm_text: 'Sind Sie sicher, dass Sie diese Nachricht senden möchten?',
        confirm_text_near_by_check_box: 'Nachricht geprüft',
        send_button_label: '@:upload_common.send',
      },
      send_complete: {
        // toast_text:
      },
      delete_confirm: {
        modal_title: 'Diese Nachricht löschen',
        confirm_text: 'Sind Sie sicher, dass Sie diese Nachricht löschen möchten?',
        delete_button_label: '@:settings.button.do_delete',
      },
      log: {
        title: 'Verlauf senden',
        send_status: {
          success: 'Gesendet',
          failure: 'Senden fehlgeschlagen',
        },
      },
    },
  },
}
